export default __webpack_public_path__ + "static/media/how_to_play_background.e502d9bd.png";